import { RigidBody } from "@react-three/rapier";
import { GROUND_Y } from "../config/game";
import { threeColors } from "../theme/tokens";

/** Invisible collision bed for the Heap pile. */
export function Ground() {
  return (
    <group position={[0, GROUND_Y, 0]}>
      <RigidBody type="fixed" colliders="cuboid" friction={0.9} restitution={0.05}>
        <mesh receiveShadow position={[0, -0.12, 0]} visible={false}>
          <boxGeometry args={[14, 0.24, 14]} />
          <meshStandardMaterial color={threeColors.ink} />
        </mesh>
      </RigidBody>
    </group>
  );
}
